import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
// import 'buefy/dist/buefy.css'
import './styles/main.scss';

import AOS from 'aos'
import 'aos/dist/aos.css'

Vue.use(Buefy);
Vue.config.productionTip = false;

new Vue({
  created () {
    AOS.init()
  },
  render: h => h(App),
}).$mount('#app')
